'use client';

import { Helmet } from 'react-helmet-async';
import { Link } from '@/components/shared/Link';
import { useTranslations } from '@/i18n/intl';

export default function NotFoundPage() {
  const tCommon = useTranslations('Common');

  return (
    <>
      <Helmet>
        <title>Page Not Found | Simisi&Co.</title>
        <meta name="description" content="The page you are looking for could not be found." />
      </Helmet>
      <section className="bg-navy pt-[120px] md:pt-[160px] pb-10 md:pb-[72px] px-5 md:px-[40px]">
        <div className="max-w-[1170px] mx-auto text-center">
          <h1 className="text-[36px] md:text-[48px] lg:text-[55px] font-bold text-white leading-tight font-heading mb-4">
            404
          </h1>
          <p className="text-[16px] md:text-[18px] text-white/70 font-sans mb-8">
            The page you are looking for could not be found.
          </p>
          <Link
            href="/"
            className="inline-flex items-center bg-primary text-white text-[14px] font-semibold px-[25px] py-[11px] rounded-[25px] hover:bg-white hover:text-navy transition-all duration-300"
          >
            {tCommon('home')}
          </Link>
        </div>
      </section>
    </>
  );
}
